/**
 * 事件管理
 * Bai.Zhiming
 * 2019-06-19 
 */
angular.module('hEditEventModule', []).
controller("hEditEventCtrl", ["$scope", "hiddenCodeManagementService", "modalDialog", "$q", "trsHttpService", "$state", function($scope, hiddenCodeManagementService, modalDialog, $q, trsHttpService, $state) {
    initStatus();
    initData();
    /**
     * [save description] 保存
     * @return {[type]} [description]
     */
    $scope.save = function() {
        if (!$scope.status.selectedLevel3) {
            modalDialog.alertType("请将信息补充完整", "", "warning", "confirm");
            return;
        }
        let params = {
            serviceid: "mlf_buridecode",
            methodname: "updatestat",
            id: $scope.status.eventInfo.id,
            /*module: JSON.stringify(angular.copy($scope.status.selectedLevel1)),
            classify: JSON.stringify(angular.copy($scope.status.selectedLevel2)),
            pages: JSON.stringify(angular.copy($scope.status.selectedLevel3)),
            operbutton: JSON.stringify(angular.copy($scope.status.selectedLevel4)),*/
            module: $scope.status.selectedLevel1.parentclassify,
            classify: $scope.status.selectedLevel2.parentclassify,
            pages: $scope.status.selectedLevel3.parentclassify,
            operbutton: $scope.status.selectedLevel4.parentclassify
        };
        $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(data => {
            modalDialog.alertType("保存成功", "", "success", false, () => {
                $state.go("manageconfig.sysmanage.hiddencodemanagement.eventmanagement", {}, { reload: "manageconfig.sysmanage.hiddencodemanagement.eventmanagement" });
            });
        });
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $state.go("manageconfig.sysmanage.hiddencodemanagement.eventmanagement", {}, { reload: false });
    };
    /**
     * [selectLevel1 description] 选中一级分类id
     * @param  {[type]} item [description] 被选中的分类
     * @return {[type]}      [description]
     */
    $scope.selectLevel1 = function(item) {
        if (!$scope.status.selectedLevel1 || $scope.status.selectedLevel1.id != item.id) {
            $scope.status.selectedLevel2 = "";
            $scope.status.selectedLevel3 = "";
            $scope.status.selectedLevel4 = "";
            $scope.data.level2Data = [];
            $scope.data.level3Data = [];
            $scope.data.level4Data = [];
            $scope.status.selectedLevel1 = item;
            getLevel2Data(item.id);
        }
    };
    /**
     * [selectLevel2 description] 选中二级分类id
     * @param  {[type]} item [description] 被选中的分类
     * @return {[type]}      [description]
     */
    $scope.selectLevel2 = function(item) {
        if (!$scope.status.selectedLevel2 || $scope.status.selectedLevel2.id != item.id) {
            $scope.status.selectedLevel3 = "";
            $scope.status.selectedLevel4 = "";
            $scope.data.level3Data = [];
            $scope.data.level4Data = [];
            $scope.status.selectedLevel2 = item;
            getLevel3Data(item.id);
        }
    };
    /**
     * [selectLevel3 description] 选中三级分类id
     * @param  {[type]} item [description] 被选中的分类
     * @return {[type]}      [description]
     */
    $scope.selectLevel3 = function(item) {
        if (!$scope.status.selectedLevel3 || $scope.status.selectedLevel3.id != item.id) {
            $scope.status.selectedLevel4 = "";
            $scope.status.selectedLevel3 = item;
            $scope.data.level4Data = [];
            getLevel4Data(item.id);
        }
    };
    /**
     * [selectLevel4 description] 选中四级分类id
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.selectLevel4 = function(item) {
        if ($scope.status.selectedLevel4 && $scope.status.selectedLevel4.id == item.id) {
            $scope.status.selectedLevel4 = "";
        } else {
            $scope.status.selectedLevel4 = item;
        }
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            eventInfo: JSON.parse(decodeURIComponent($state.params.eventinfo))
        };
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        getLevel1Data();
    }
    /**
     * [getLevel1Data description] 获取一级数据
     * @return {[type]} [description]
     */
    function getLevel1Data() {
        getClassify(0).then(resp => {
            $scope.data.level1Data = resp.data;
        });
    }
    /**
     * [getLevel2Data description] 获取二级分类id
     * @param  {[type]} id [description] 所属一级分类id
     * @return {[type]}    [description]
     */
    function getLevel2Data(id) {
        getClassify(id).then(resp => {
            $scope.data.level2Data = resp.data;
        });
    }
    /**
     * [getLevel3Data description] 获取三级分类id
     * @param  {[type]} id [description] 所属二级分类
     * @return {[type]}    [description]
     */
    function getLevel3Data(id) {
        getClassify(id).then(resp => {
            $scope.data.level3Data = resp.data;
        });
    }
    /**
     * [getLevel4Data description] 获取四级分类id
     * @param  {[type]} id [description] 所属二级分类
     * @return {[type]}    [description]
     */
    function getLevel4Data(id) {
        getClassify(id).then(resp => {
            $scope.data.level4Data = resp.data;
        });
    }
    /**
     * [getClassify description] 获取分类信息
     * @param  {[type]} classifyId [description] 分类id
     * @return {[type]}          [description]
     */
    function getClassify(classifyId) {
        let deffer = $q.defer();
        let params = {
            serviceid: "mlf_buridecode",
            methodname: "get",
            parentid: classifyId
        };
        $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
            deffer.resolve(resp);
        });
        return deffer.promise;
    }
}]);